import * as React from 'react';
import { Media } from '.';

interface Props {
  id?: string;
  type?: 'moveHorz'|'moveHorzReverse'|'moveVert'|'moveVertReverse'|'moveAll'|'moveAllReverse'|'moveHorzAndVertReverse'|'moveVertAndHorzReverse';
  imageUrl: string;
  left?: string | number;
  top?: string | number;
  height?: string | number;
  width?: string | number;
  alt?: string;
}

export const ParallaxMouseMove: React.FunctionComponent<Props> = (props) => {;
  const [transform, setTransform] = React.useState('');
  const type = props.type || 'moveHorz';
  const signX = type.includes('AllReverse') || type.includes('HorzReverse')? 1 : -1;
  const signY = type.includes('AllReverse') || type.includes('VertReverse')? 1 : -1;
  const move = 5;

  const onMouseMove = React.useCallback((e: MouseEvent) => { 
    const offsetX = (window.innerWidth + signX * e.pageX * move) / 90
    const offsetY = (window.innerWidth + signY * e.pageY * move) / 90
    setTransform(`translateX(${offsetX}px) translateY(${offsetY}px)`);
  }, [signX, signY]);

  React.useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
    }
  }, [])

  
  return (
    <Media id={props.id} url={props.imageUrl} sx={{position: 'absolute', transform: transform, height: props.height, width: props.width, left: props.left, top: props.top}}/>
    )
}
